export default {
  text: 'Du hast {{points}} Punkte ({{amount}}) bei dieser Bestellung verdient',
  button: 'Login und Punkte sichern',
};
